function test_ready(fn){
    if(document.addEventListener){
            document.addEventListener('DOMContentLoaded',function(){
                document.removeEventListener('DOMContentLoaded',arguments.callee,false);
                fn();
            },false);
     }else if(document.attachEvent){
          document.attachEvent('onreadystatechange',function(){
               if(document.readyState=='complete'){
                    document.detachEvent('onreadystatechange',arguments.callee);
                    fn();
               }
          });
    }
}
  test_ready(() => {            
		jQuery('.product-description .tabs.ymq_pc_show li').click(function(){
  jQuery('.product-description .tabs li').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.tabs-content-item').removeClass('active');
  jQuery('.'+jQuery(this).data('tab')).addClass('active');
})
jQuery('.product-description .tabs.ymq_m_show li').click(function(){
  jQuery('.ymq_m_show li').removeClass('grouped-content-trigger');
  if (jQuery('.'+jQuery(this).data('tab')).hasClass('active')) {
    jQuery(this).removeClass('active');
    jQuery('.'+jQuery(this).data('tab')).removeClass('active');
  }else{
    jQuery(this).addClass('active');
    jQuery('.'+jQuery(this).data('tab')).addClass('active');
  }
}) 
jQuery('.downloads-tab,.accessorie-tab').click();
  jQuery('.downloads-tab,.accessorie-tab').click().removeClass('active');
	
  }); 

  // 产品主图下的促销倒计时
  document.addEventListener('DOMContentLoaded', function() {
    if($("#promotion_clock")){
      var d, h, m, s;
      // 1.设置结束时间
      let endDate = new Date('2026/01/05 16:00:00');

      function updateCountdown() {
          const now = new Date();

          // 3.将用户访问时间统一为UTC+8
          now.setUTCHours(now.getUTCHours() + (now.getTimezoneOffset() + 8 * 60) / 60);

          // 5.获取时间差 = 结束时间戳 - 开始时间戳
          let startTime = now.getTime()
          let endTime = endDate.getTime()

          // 6. 将时间差转换为小时、分钟和秒
          if (endTime >= startTime) {
              timeArr(endTime - startTime)
              function checkTime(i){
                  if (i<10) {
                      i = "0"+i;
                  }
                  return i;
              }
              document.getElementById("promotion_clock").innerHTML = `${checkTime(d)} : ${checkTime(h)} : ${checkTime(m)} : ${checkTime(s)}`;
          }
      }
      function timeArr(timeLeft){
          d = Math.floor(timeLeft/1000/60/60/24);
          h = Math.floor(timeLeft/1000/60/60%24);
          m = Math.floor(timeLeft/1000/60%60);
          s = Math.floor(timeLeft/1000%60);
      }

      setInterval(updateCountdown, 1000);
    }
  });

// product highlights
window.onload = function() {
  if(window.screen.width > 1024){
    if($(".product-gallery--image").length>0){
      $(".product__container .product-gallery .product-highlights").show()
    }
  }else{
      $(".product__container .product-main .product-highlights").show()
  }
};